import { useSiteInfo } from '@contexts/SiteInfoContext';
import { Swiper, SwiperSlide } from 'swiper/react';
import ServerPath from '../../configs/serverPath';
import { providerSwiperConfig } from './swiperConfig';

const Footer3rdPartyProvider = () => {
    const { composePath } = useSiteInfo();

    const logoList = () => {
        const fileList = [
            'Allbet.png',
            'Arvadiv.png',
            'BetBuilder.png',
            'BetRadar.png',
            'Inspire.png',
            'Lottery.png',
            'MetricGaming.png',
            'PragmaticPlay.png',
            'RNGKeno.png',
            'Saba.png',
            'Sexy.png',
            'Spadegaming.png',
            'TableGames.png',
            'VirtualGame.png',
        ];

        const list = fileList.map((fileName) => composePath(
            { pathType: ServerPath.siteImage, pathName: `provider/${fileName}` },
        ));

        return list;
    };

    return (
        <div className="footer__provider">
            <div className="provider">
                <Swiper
                    {...providerSwiperConfig}
                    loop
                >
                    {logoList().map((imageUrl) => (
                        <SwiperSlide key={imageUrl}>
                            <div className="swiper__item">

                                <img
                                    className="swiper-lazy swiper-lazy-loaded"
                                    alt=""
                                    src={imageUrl}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default Footer3rdPartyProvider;
